import React, { useState, createContext, useContext } from 'react';
interface DeliveryInfo {
  address: string;
  postalCode: string;
  date: string;
  timeSlot: string;
  mealType: string;
}
interface GroupOrderInfo {
  id: string;
  name: string;
  expiresAt: Date;
  individualPayment: boolean;
  participants: {
    id: string;
    name: string;
    items: any[];
  }[];
}
interface OrderContextType {
  deliveryInfo: DeliveryInfo | null;
  setDeliveryInfo: (info: DeliveryInfo) => void;
  createOrder: (paymentMethod: string) => Promise<string>;
  getOrderStatus: (orderId: string) => any;
  groupOrders: GroupOrderInfo[];
  createGroupOrder: (data: any) => Promise<string>;
  joinGroupOrder: (id: string) => Promise<void>;
  getCurrentGroupOrder: () => GroupOrderInfo | null;
}
const OrderContext = createContext<OrderContextType | undefined>(undefined);
export const OrderProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [deliveryInfo, setDeliveryInfo] = useState<DeliveryInfo | null>(null);
  const [groupOrders, setGroupOrders] = useState<GroupOrderInfo[]>([]);
  const [currentGroupOrder, setCurrentGroupOrder] = useState<string | null>(null);
  // Mock implementation for demo purposes
  const createOrder = async (paymentMethod: string) => {
    // In a real app, this would call an API
    return 'order-123';
  };
  const getOrderStatus = (orderId: string) => {
    // In a real app, this would call an API
    return {
      status: 'preparing',
      estimatedDelivery: '12:30 PM',
      items: []
    };
  };
  const createGroupOrder = async (data: any) => {
    const id = `JC${Math.floor(Math.random() * 1000000000).toString().padStart(9, '0')}SL`;
    const newGroupOrder = {
      id,
      name: data.name,
      expiresAt: new Date(Date.now() + 3600000),
      individualPayment: data.individualPayment,
      participants: [{
        id: 'user-123',
        name: 'Terry Crews',
        items: []
      }]
    };
    setGroupOrders(prev => [...prev, newGroupOrder]);
    setCurrentGroupOrder(id);
    return id;
  };
  const joinGroupOrder = async (id: string) => {
    setCurrentGroupOrder(id);
  };
  const getCurrentGroupOrder = () => {
    if (!currentGroupOrder) return null;
    return groupOrders.find(go => go.id === currentGroupOrder) || null;
  };
  return <OrderContext.Provider value={{
    deliveryInfo,
    setDeliveryInfo,
    createOrder,
    getOrderStatus,
    groupOrders,
    createGroupOrder,
    joinGroupOrder,
    getCurrentGroupOrder
  }} data-id="element-195">
      {children}
    </OrderContext.Provider>;
};
export const useOrder = () => {
  const context = useContext(OrderContext);
  if (context === undefined) {
    throw new Error('useOrder must be used within an OrderProvider');
  }
  return context;
};